import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { StyledAccountData } from "../styled/CuentaCorriente";


const CuentaCorrienteAccountData = () => {

  const { error: errorAnalistaDeCuenta, loading: loadingAnalistaDeCuenta, data } = useSelector((state) => state.cuentaCorriente.analistaDeCuenta);

  const { nombreCompleto, telefono, email } = data || {};
  const accountDataExists = nombreCompleto || telefono || email;



  useEffect(() => {
    if (data && !loadingAnalistaDeCuenta && !errorAnalistaDeCuenta && !accountDataExists) {
      toast.warn(
        "La ART no tiene configurado los datos del Analista de Cuenta, ante cualquier consulta comunicarse directamente con la ART",
        { toastId: "analistaDeCuentaCorrienteVacio" }
      )
    }

  }, [data, loadingAnalistaDeCuenta, errorAnalistaDeCuenta, accountDataExists]);


  return (

    <StyledAccountData.Container>
      <StyledAccountData.Title>Analista de Cuenta</StyledAccountData.Title>
      {data && !accountDataExists ?
        <StyledAccountData.Error> La ART no tiene configurado los datos </StyledAccountData.Error>
        :
        <>
          <StyledAccountData.Subtitle>{nombreCompleto}</StyledAccountData.Subtitle>
          {telefono && <StyledAccountData.  Subtitle>Teléfono: {telefono}</StyledAccountData.Subtitle>}
          <StyledAccountData.SubtitleMail>{email}</StyledAccountData.SubtitleMail>
        </>
      }

    </StyledAccountData.Container>

  )


};

export default CuentaCorrienteAccountData;
